"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _index = require("../FilterBar/index.js");

var _index2 = _interopRequireDefault(_index);

var _constants = require("./constants");

var _ActionBar = require("./ActionBar");

var _ActionBar2 = _interopRequireDefault(_ActionBar);

var _testing = require("./context/testing");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FilterBar = function FilterBar(props) {
  var _useTestingContext = (0, _testing.useTestingContext)(),
      testId = _useTestingContext.testId;

  return _react2.default.createElement(_ActionBar2.default, {
    id: _constants.NAMESPACES.FILTER_BAR,
    testId: testId + "__filter-bar",
    order: _constants.ORDER_CLASSNAMES.FILTER_BAR
  }, _react2.default.createElement(_index2.default, props));
};

exports.default = FilterBar;